import {
  getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { type AxiosError } from 'axios';

export const usePostClientAdminUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsClientAdminUsersMutationFetcher(threeLetterCode),
    options
  );
